import { render, staticRenderFns } from "./ChatHistoryAvatar.vue?vue&type=template&id=0301623c&"
import script from "./ChatHistoryAvatar.vue?vue&type=script&lang=js&"
export * from "./ChatHistoryAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports